import { Component, OnDestroy, OnInit } from '@angular/core';
import { Form } from '../../../domain/form.interface';
import { Value } from '../../../domain/value.interface';
import { Subject, takeUntil } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { ColumnMode, SelectionType } from '@swimlane/ngx-datatable';
import { Location } from '@angular/common';
// Selectors
import { setSelectedForm } from '../../../infrastructure/store/selectors/form.selector';
import {
  setSelectedVersion,
  setVersions,
} from '../../../infrastructure/store/selectors/version.selector';
import {
  setSelectedValue,
  setValues,
} from '../../../infrastructure/store/selectors/value.selector';
// Actions
import {
  getSelectedValue,
  loadValuesList,
} from '../../../infrastructure/store/actions/value.actions';
import { Tabs } from '../../../domain/tabs.interface';
import { getSelectedVersionSuccess } from '../../../infrastructure/store/actions/version.actions';
@Component({
  selector: 'app-launch',
  templateUrl: './launch.component.html',
  styleUrls: ['./launch.component.scss'],
})
export class LaunchComponent implements OnInit, OnDestroy {
  unsubscribe$ = new Subject();

  elementSelected!: Form; // Element selected to toggle form-version
  forms: Form[] = []; // Forms lis
  formSelected!: Form; // Form selected
  versions: Form[] = [];
  versionSelected!: Form; // Version selected
  values: Value[] = [];
  valuesData = [];
  valueSelected!: Value;
  baseUrl: string;
  versionId = '';
  formId = '';

  /*DATA TABLE*/
  columnMode = ColumnMode;
  selectionType = SelectionType;
  showSearchToolbar: boolean = false;
  selectedData: any[] = [];
  selectedProperties = [];
  /*selectedProperties = [
    {
      label: 'Data',
      name: 'data',
    }
  ];*/

  isPreview = false;

  tabs: Tabs[] = [
    { label: 'Results', value: '1' },
    { label: 'Sharing', value: '2' },
  ];
  viewSelected: string = '1';

  constructor(private store: Store, private location: Location) {}

  ngOnInit(): void {
    this.store
      .pipe(select(setVersions))
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: (v) => {
          this.versions = v;
        },
        error: (e) => {
          console.log('ERROR->', <any>e);
        },
      });

    this.store
      .pipe(select(setSelectedForm))
      .pipe(
        //filter(x => x.status == "success"),
        takeUntil(this.unsubscribe$)
      )
      .subscribe({
        next: (v) => {
          this.formSelected = v;

          if (v) {
            this.elementSelected = v;
            this.versionId = 'latest';
            this.formId = v.sk;
            this.generateShareUrl();
          }
        },
        error: (e) => {
          console.log('ERROR->', <any>e);
        },
      });

    this.store
      .pipe(select(setSelectedVersion))
      .pipe(
        //filter(x => x.status == "success"),
        takeUntil(this.unsubscribe$)
      )
      .subscribe({
        next: (v) => {
          this.versionSelected = v;
          console.log(this.versionSelected);

          if (v) {
            this.elementSelected = v;
            this.versionId = v.sk;
            this.formId = v.form_id;
            this.generateShareUrl();
            this.selectedProperties = [];
            this.selectedData = [];
            // Get table properties
            this.elementSelected.fields.forEach((value, index) => {
              let prop = {
                label: value.name,
                name: value.name,
              };
              this.selectedProperties.push(prop);
            });
            // Load values list
            this.store.dispatch(
              loadValuesList({
                formId: this.formSelected.sk,
                versionId: this.versionSelected.sk,
              })
            );
          }
        },
        error: (e) => {
          console.log('ERROR->', <any>e);
        },
      });

    this.store
      .pipe(select(setValues))
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: (v) => {
          this.values = v;
          this.valuesData = [];

          this.values?.forEach((val, index) => {
            this.valuesData.push(val.data);
          });
          console.log(this.valuesData);
        },
        error: (e) => {
          console.log('ERROR->', <any>e);
        },
      });
  }

  activeTab(tab: string) {
    this.viewSelected = tab;
  }

  preview() {
    this.isPreview = !this.isPreview;
  }

  sortTable(value: any) {}

  toggleShowSearchToolbar() {
    this.showSearchToolbar = !this.showSearchToolbar;
  }

  onSelect(row: { selected: any }) {
    this.selectedData.splice(0, this.selectedData.length);
    this.selectedData.push(...row.selected);
  }

  generateShareUrl() {
    // Accessing the current URL from the browser's document object
    const currentUrl = window.location.href;
    // Extracting the base URL
    const urlParts = currentUrl.split('/');
    this.baseUrl = `${urlParts[0]}//${urlParts[2]}/fill?formId=${this.formId}&versionId=${this.versionId}&page=1&customKey=??????`;
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next(null);
    this.unsubscribe$.complete();
  }
}
